var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSimilarAccount = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 13.003,
    viewBox: "0 0 20 13.003",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29254",
    "data-name": "Group 29254",
    transform: "translate(189.438 -78.258)",
    fill: "#00a1af"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48542",
    "data-name": "Path 48542",
    d: "M-170.383,88.047a6.57,6.57,0,0,1-4.55,3.086,6.7,6.7,0,0,1-4.753-.826,1.9,1.9,0,0,1-.183-.112,6.1,6.1,0,0,1-1.945-1.843,6.144,6.144,0,0,1-.981-2.323,6.084,6.084,0,0,1,.638-4.269,3.282,3.282,0,0,1,.851.379,4.174,4.174,0,0,1,1.034.861,4.185,4.185,0,0,0,.7,4.62,4.391,4.391,0,0,0,1.013.828,3.911,3.911,0,0,0,.84.39,5.314,5.314,0,0,0,.822.2,4.473,4.473,0,0,0,5.133-3.606c.009-.066.028-.142.037-.208a4.349,4.349,0,0,0-3.775-4.73c-.27-.044-.537-.034-.8-.07a.47.47,0,0,1-.124-.017A6.267,6.267,0,0,0-178.3,78.59a10.548,10.548,0,0,1,1.085-.237,6.718,6.718,0,0,1,5.553,1.591,6.229,6.229,0,0,1,2.1,3.635A6.152,6.152,0,0,1-170.383,88.047Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48543",
    "data-name": "Path 48543",
    d: "M-177.094,87.608a.213.213,0,0,1-.078-.019,3.834,3.834,0,0,1-.833-.384,4.077,4.077,0,0,1-.949-.756,4.26,4.26,0,0,0-.809-4.621,4.371,4.371,0,0,0-.983-.788,3.49,3.49,0,0,0-.92-.4.649.649,0,0,0-.134-.048,4.328,4.328,0,0,0-5.292,2.987,4.272,4.272,0,0,0-.141.743,4.324,4.324,0,0,0,3.632,4.707c.266.041.552.039.818.07a.2.2,0,0,1,.089.018,5.874,5.874,0,0,0,1.841,1.716.537.537,0,0,0,.1.061c-.4.094-.739.207-1.1.267a6.336,6.336,0,0,1-4.3-.765,6.227,6.227,0,0,1-2.941-3.59,6.34,6.34,0,0,1,1.323-6.368,6.19,6.19,0,0,1,3.572-2.04,6.275,6.275,0,0,1,4.6.794,6.287,6.287,0,0,1,3.028,4.258A6.281,6.281,0,0,1-177.094,87.608Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSimilarAccount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_similar_account.abe510159b4eca56a4884cc6faa2b03e.svg";